


















































































































































































































































































































import Vue from "vue";
import _ from "lodash";
import { Form } from "element-ui";
import config from "../config/index";
import { exportFiles } from "../common/util";
import { mapState, mapActions } from "vuex";
import store from "../store/store";
import { TaskData } from "../types/common";
import { PaperCheckData, OptData, CheckFileDto } from "../types/paperCheck";
import { uploadFileStatus } from "../common/filters";
import CheckDialog from "./CheckDialog.vue";
Vue.component("checked-component", CheckDialog);

declare var _hmt: any;
declare var captcha: any;

export default Vue.extend({
	name: "PaperCheck",
	data(): PaperCheckData {
		return {
			checkTypeLocal: "upload",
			isTraditional: false,
			isFolder: false,
			isShowFolderName: false,
			isShowAddFolder: false,
			isAddFolder: true,
			oldFolderId: "",
			listLoading: false,
			isCheckResultTip: false,
			checkTime: 0,
			fileNum: 0,
			isCanCheck: false,
			checkIds: [],
			selectFileList: [],
			uploadFileList: [],
			copyUploadFileList: [],
			cacheUploadFileList: [],
			taskList: [],
			contrastMethod: 1,
			isShowCheck: false,
			checkedRow: [],
			orderTimer: null,
			operateBytes: {
				textLength: 0,
				needCount: 0,
			},
			$refs: {
				ruleForm: Form,
				folderForm: Form,
			},
			folderForm: {
				newTask: "",
				taskId: "",
				taskName: "",
			},
			folderRules: {
				newTask: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请输入文件夹名称"));
							} else if (value.length > 50) {
								callback(new Error("文件夹名称不能大于50位"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				taskId: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请选择文件夹"));
							} else {
								callback();
							}
						},
						trigger: "change",
					},
				],
			},
			ruleForm: {
				title: "",
				author: "",
				content: "",
				publishTime: "",
			},
			rules: {
				title: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请填写题名"));
							} else if (value.length > 200) {
								callback(new Error("题名长度不能大于200个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				author: [
					{
						required: false,
						validator: (rule: any, value: any, callback: any) => {
							if (value.length > 150) {
								callback(new Error("作者名称长度不能大于150个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				content: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请粘贴文本"));
							} else if (value.length > 1000000) {
								callback(new Error("内容长度不能大于100万字符"));
							} else {
								callback();
							}
						},
						trigger: "change",
					},
				],
			},
			isTipsShow: false,
			isTips: false,
			tipText:
				'尊敬的用户您好，"万方检测”报告服务将在3月初全面升级为“万方数据文察”报告服务，保留原“万方检测”全部功能，并在检测报告上做出重磅优化。优化内容详见：https://cx.wanfangdata.com.cn/#/detectionReportUpgradeNotice',
		};
	},
	computed: mapState({
		userInfo: (state: any) => store.getters.getUserInfo,
		paperType: (state: any) => store.getters.getPaperType,
		checkType: (state: any) => store.getters.getCheckType,
		isShowIntro: (state: any) => store.getters.getIntro,
		uploader: (state: any) => store.getters.getUploader,
		checkHomeUrl: (state: any) => store.getters.getCheckHomeUrl,
	}),
	watch: {
		isShowIntro(newVal) {
			if (newVal && this.uploadFileList.length === 0) {
				this.uploadFileList = [
					{
						author: "张伟",
						checkId: "",
						status: "上传成功",
						title: "相似性检测论文",
					},
				];
			} else {
				this.uploadFileList = this.copyUploadFileList.concat([]);
			}
		},
		checkType(newVal) {
			this.checkTypeLocal = newVal;
		},
	},
	methods: {
		// 修改弹出状态
		changeCacheTips() {
			this.isTipsShow = false;
			localStorage.setItem("alShowToast", JSON.stringify(this.isTips));
		},
		// 重置文件夹状态
		resetFolder() {
			this.isTraditional = false;
			this.isFolder = false;
			this.isShowFolderName = false;
			this.folderForm = {
				newTask: "",
				taskId: "",
				taskName: "",
			};
			this.resetForm("folderForm");
		},
		// 查看在线报告
		getOnLineReportLink(row: any) {
			const checkTypeTable: any = {
				WFDB: "JA",
				OneByOne: "JAYD",
			};
			if (row.checkType === "OneByOne") {
				window.open(`${this.checkHomeUrl}reportweb/?reportId=${row.checkId}&productId=${checkTypeTable[row.checkType]}&checkType=OneByOne`, "_blank");
			} else {
				window.open(`${this.checkHomeUrl}reportweb/?reportId=${row.checkId}&productId=${checkTypeTable[row.checkType]}&reportType=originalText`, "_blank");
			}
		},
		changeThanRadio(val: any) {
			this.getNotCheckList();
			this.initUploader("#newPaper", {
				multiple: val === 1 ? true : false,
				fileNumLimit: val === 1 ? 100 : 1,
				type: "newPaper",
			});
		},
		handleToPdf() {
			let routeUrl = this.$router.resolve({
				path: "/pdf",
			});
			window.open(routeUrl.href, "_blank");
		},
		// 修改检测类型触发方法
		changeCheckType() {
			// 事件追踪start
			if (this.checkType === "operation") {
				_hmt.push(["_trackEvent", "我的检测-文献送检", "手工录入", "事件价值", 1]);
			}
			// end
			this.$store.dispatch("setCheckType", this.checkTypeLocal);
			this.resetFolder();
			this.resetForm("ruleForm");

			this.operateBytes = {
				textLength: 0,
				needCount: 0,
			};
		},
		// 修改收稿日期触发方法
		changeDate(val: any) {
			console.log("修改了日期");
		},
		// 选择、取消上传文件钩子方法
		handleSelectionChange(val: CheckFileDto[]) {
			this.selectFileList = val;
			this.checkIds = [];
			_.forEach(this.selectFileList, (value: CheckFileDto) => {
				this.checkIds.push(value.checkId);
			});
		},
		// 删除选中文件
		delFileList(row?: any) {
			if (this.checkIds.length === 0 && !row) {
				this.$alert(" 请至少选择一条检测信息！", "提示");
				return false;
			}
			this.$confirm("是否确认删除？", "提示", { type: "warning" })
				.then(() => {
					let checkIdList = [];
					// 单个删除
					if (row) {
						this.uploadFileList = _.differenceWith(this.uploadFileList, [row], _.isEqual);
						checkIdList = [row.checkId];
					} else {
						// 批量删除
						this.uploadFileList = _.differenceWith(this.uploadFileList, this.selectFileList, _.isEqual);
						checkIdList = this.checkIds;
					}
					this.copyUploadFileList = this.uploadFileList.concat([]);
					this.$store.dispatch("setLoading", {
						isShow: true,
					});
					this.$http
						.delete("/api/Check/Delete/CheckFile", {
							data: {
								checkIds: checkIdList,
							},
						})
						.then((data: any) => {
							this.$store.dispatch("setLoading", {
								isShow: false,
							});
							this.handleSelectionChange([]);
							this.$message({
								message: `删除成功`,
								type: "success",
							});
							this.fileNum = this.uploadFileList.length;
						})
						.catch(() => {
							this.$store.dispatch("setLoading", {
								isShow: false,
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		// 获取文件夹列表
		getTaskList() {
			this.$http.get("/api/Folder/FolderList").then((data: any) => {
				this.taskList = data.result;
			});
		},
		// 是否添加至文件夹
		changeFolderStatus(val: boolean) {
			if (!this.isFolder) {
				this.isShowFolderName = this.isFolder;
			}
			val === true && !this.taskList.length ? (this.isAddFolder = false) : "";
			this.isShowAddFolder = val && !this.isShowFolderName;
		},
		// 关闭文件夹弹窗
		closeFolderDialog() {
			if (!this.isShowFolderName) {
				this.isFolder = false;
			}
		},
		// 改变文件夹类型事件
		changeFolderType() {
			this.$refs.folderForm.resetFields();
		},
		// 已有文件夹change事件
		changeTask(id: string) {
			let obj: TaskData | any = {};
			obj = this.taskList.find((item: TaskData) => {
				return item.taskId === id;
			});
			this.folderForm.taskName = (obj && obj.taskName) || "";
		},
		// 创建文件夹
		createFolder() {
			this.$http
				.post(`/api/Folder/Create`, {
					folderName: this.folderForm.newTask,
				})
				.then((data: any) => {
					const result = data.result;
					Object.assign(this.folderForm, {
						taskId: result.item1,
						taskName: result.item2,
					});
					this.isAddFolder = true;
					this.getTaskList();
					this.$message({
						message: `创建成功`,
						type: "success",
					});
					this.isShowFolderName = true;
					this.changeFolderStatus(false);
				});
		},
		// 添加至文件夹
		intoFolder() {
			this.$refs.folderForm.validate((valid: any) => {
				if (valid) {
					if (!this.isAddFolder) {
						this.createFolder();
					} else {
						this.isShowFolderName = true;
						this.changeFolderStatus(false);
					}
				}
			});
		},
		// 下载报告
		download(checkId: string) {
			exportFiles(`/api/Check/DownLoad/CheckFile/${checkId}`, location.origin + config.api);
		},
		// 获取未检测文件列表
		getNotCheckList() {
			this.$http.get(`/api/Check/CheckFileList/${this.contrastMethod === 1 ? 0 : this.contrastMethod === 2 ? 1 : 2}`).then((data: any) => {
				this.uploadFileList = data.result;
				this.fileNum = this.uploadFileList.length;
				this.copyUploadFileList = this.uploadFileList.concat([]);
			});
		},
		handleInputContent() {
			clearTimeout(this.orderTimer);
			this.orderTimer = setTimeout(() => {
				this.$http
					.post(`/api/Check/GetLengthAndCount`, {
						content: this.ruleForm.content,
					})
					.then((res: any) => {
						res.isSucceed ? (this.operateBytes = res.result) : "";
					})
					.catch((err: any) => {});
			}, 1500);
		},
		// 新文献检测开始检测
		startCheck(type: string, formName?: string) {
			const param: any = {
				isConvert: this.isTraditional,
				taskId: this.folderForm.taskId,
			};
			if (this.contrastMethod !== 1 && !this.checkedRow.length) {
				this.$alert("未选择已检测文献信息，无法送检！", "提示");
				return false;
			}
			if (type === "upload") {
				if (this.uploadFileList.length === 0) {
					this.$alert("未上传文献，无法送检！", "提示");
					return false;
				}
				const mark = this.judgeStatus();
				if (!mark) {
					this.$alert("文件列表中包含上传失败的送检文献，请从列表中删除这些文献后再进行送检。", "提示");
					return false;
				}
				let checkIds = [];
				// 上传文件checkId集合
				checkIds = _.map(this.uploadFileList, "checkId");
				// 集合为空时提示
				if (_.isArray(checkIds) && checkIds.length !== 0) {
					this.$store.dispatch("setLoading", {
						isShow: true,
					});
					Object.assign(param, {
						checkIds,
					});
					// 事件追踪start
					if (this.isTraditional) {
						_hmt.push(["_trackEvent", "我的检测-文献送检", "送检繁体文献", "事件价值", 1]);
					}
					if (this.folderForm.taskId) {
						_hmt.push(["_trackEvent", "我的检测-文献送检", "保存至文件夹", "事件价值", 1]);
					}
					// end
					// 无痕验证
					(param as any).nvc = captcha.getNVCVal();

					let ajaxUrl = "";
					if (this.contrastMethod === 1) {
						ajaxUrl = "/api/Check/Upload/NewCheck"; // 上传【万方】
						param.bothCheck = false;
					} else if (this.contrastMethod === 2) {
						ajaxUrl = "/api/Check/Upload/NewCheck2"; // 上传【一对一】
						param.thanPaperId = this.checkedRow[0].checkId;
						param.bothCheck = false;
					} else if (this.contrastMethod === 3) {
						ajaxUrl = "/api/Check/Upload/NewCheck2"; // 上传【万方+一对一】
						param.thanPaperId = this.checkedRow[0].checkId;
						param.bothCheck = true;
					}

					// end
					this.$http
						.post(ajaxUrl, param)
						.then((data: any) => {
							// 无痕验证未通过
							if (!captcha.callback(data)) {
								this.$store.dispatch("setLoading", {
									isShow: false,
								});
								return;
							} else {
								if (this.contrastMethod === 3) {
									param.nvc = captcha.getNVCVal();
									ajaxUrl = "/api/Check/Upload/NewCheck";
									param.checkIds = [data.wFdbcheckId];
									this.$http.post(ajaxUrl, param).then((dataa: any) => {
										// 无痕验证未通过
										if (!captcha.callback(dataa)) {
											this.$store.dispatch("setLoading", {
												isShow: false,
											});
											return;
										} else {
											this.$message({
												message: `送检成功`,
												type: "success",
											});
											// 重新更新全局状态
											this.$store.dispatch("setUserInfo");
											this.handleSelectionChange([]);
											this.getNotCheckList();
											this.checkTime = dataa.result && typeof dataa.result === "number" ? dataa.result : 1;
											this.isCheckResultTip = true;
										}
									});
								} else {
									this.$message({
										message: `送检成功`,
										type: "success",
									});
									// 重新更新全局状态
									this.$store.dispatch("setUserInfo");
									this.handleSelectionChange([]);
									this.getNotCheckList();
									this.checkTime = data.result && typeof data.result === "number" ? data.result : 1;
									this.isCheckResultTip = true;
								}
							}
						})
						.catch(() => {
							this.$store.dispatch("setLoading", {
								isShow: false,
							});
						});
				} else {
					this.$message({
						message: "请选择上传文件",
						type: "error",
					});
				}
			} else {
				formName = formName || "";
				// 手工录入异步表单验证
				this.$refs[formName].validate((valid: any) => {
					if (valid) {
						this.$store.dispatch("setLoading", {
							isShow: true,
						});
						Object.assign(param, this.ruleForm);
						// 事件追踪start
						if (this.isTraditional) {
							_hmt.push(["_trackEvent", "我的检测-文献送检", "送检繁体文献", "事件价值", 1]);
						}
						if (this.folderForm.taskId) {
							_hmt.push(["_trackEvent", "我的检测-文献送检", "保存至文件夹", "事件价值", 1]);
						}
						// end
						// 无痕验证
						param.nvc = captcha.getNVCVal();
						// end
						let ajaxUrl = "/api/Check/Manul/NewCheck";
						if (this.contrastMethod === 1) {
							ajaxUrl = "/api/Check/Manul/NewCheck"; // 手工【万方】
						} else if (this.contrastMethod === 2) {
							ajaxUrl = "/api/Check/Manul/NewCheck2"; // 手工【一对一】
							param.thanPaperId = this.checkedRow[0].checkId;
						}

						this.$http
							.post(ajaxUrl, param)
							.then((data: any) => {
								// 无痕验证未通过
								if (!captcha.callback(data)) {
									this.$store.dispatch("setLoading", {
										isShow: false,
									});
									return;
								} else {
									if (this.contrastMethod === 3) {
										param.nvc = captcha.getNVCVal();
										ajaxUrl = "/api/Check/Manul/NewCheck2"; // 手工【万方+一对一】调两个接口
										param.thanPaperId = this.checkedRow[0].checkId;
										this.$http.post(ajaxUrl, param).then((dataa: any) => {
											// 无痕验证未通过
											if (!captcha.callback(dataa)) {
												this.$store.dispatch("setLoading", {
													isShow: false,
												});
												return;
											} else {
												this.$message({
													message: `送检成功`,
													type: "success",
												});
												// 重新更新全局状态
												this.$store.dispatch("setUserInfo");
												this.resetForm(formName);
												this.checkTime = dataa.result && typeof dataa.result === "number" ? dataa.result : 1;
												this.isCheckResultTip = true;
											}
										});
									} else {
										this.$message({
											message: `送检成功`,
											type: "success",
										});
										// 重新更新全局状态
										this.$store.dispatch("setUserInfo");
										this.resetForm(formName);
										this.checkTime = data.result && typeof data.result === "number" ? data.result : 1;
										this.isCheckResultTip = true;
									}
								}
							})
							.catch(() => {
								this.$store.dispatch("setLoading", {
									isShow: false,
								});
							});
					} else {
						return false;
					}
				});
			}
		},
		// 清空、重置表单
		resetForm(formName: any) {
			if (this.$refs[formName]) {
				this.$refs[formName].resetFields();
			}
		},
		// 跳转到检测结果
		toCheckResult() {
			let path = "/myCheckInfo";
			this.$router.push({
				path,
			});
		},
		// 判断上传文件状态
		judgeStatus() {
			let mark = true;
			this.uploadFileList.forEach((item: any) => {
				if (item.status !== "Success") {
					mark = false;
				}
			});
			return mark;
		},
		// 上传成功回调
		handleSuccess(file: any, response: any) {
			this.uploadFileList.forEach((item: any, index: any) => {
				if (file.id === item.id) {
					this.uploadFileList.splice(index, 1, response);
				}
			});
			this.copyUploadFileList = this.uploadFileList.concat([]);
		},
		// 上传错误回调
		handleError(error: any, file: any, type: string) {
			if (error === "Q_TYPE_DENIED" && file.size !== 0) {
				this.$message({
					message: "文件格式不正确，仅限doc,docx,pdf,txt,rtf",
					type: "error",
				});
			} else if (error === "F_EXCEED_SIZE") {
				// this.$message({
				//   message: `文件大小超过上限30M，请重新上传`,
				//   type: 'error'
				// });
			} else if (error === "Q_EXCEED_NUM_LIMIT") {
				this.$message({
					message: `单次送检不超过100篇`,
					type: "error",
				});
			}
		},
		// 禁止上传提示
		tips() {
			this.$alert("当前还有未上传完的文档，请在完成后继续选择文档上传", "提示");
			return false;
		},
		// 初始化上传组件
		initUploader(domId: string, opt: OptData) {
			// 初始化前，如果有上传对象，清空上传队列
			if (this.uploader) {
				this.uploader.reset();
				this.getNotCheckList();
			}
			const webUploaderOpt = {
				auto: true, // 是否自动上传
				// fileSingleSizeLimit: opt.type === 'newPaper' ? 30 * 1024 * 1024 : undefined,
				// fileSingleSizeLimitStr: opt.type === 'newPaper' ? '30M' : undefined,
				fileNumLimit: opt.fileNumLimit,
				threads: 1,
				// swf文件路径
				swf: "/public/js/Uploader.swf?_t=" + new Date().getTime(),
				// 文件接收服务端。
				server: `${config.api}/api/Check/Upload/${this.contrastMethod === 1 ? 0 : this.contrastMethod === 2 ? 1 : 2}`,
				// 选择文件的按钮。可选。
				// 内部根据当前运行是创建，可能是input元素，也可能是flash.
				pick: {
					id: domId,
					multiple: opt.multiple,
				},
				// 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
				resize: false,
				duplicate: true,
				accept: {
					title: "Documents",
					extensions: "doc,docx,pdf,txt,rtf",
					mimeTypes: ".docx,.doc,.pdf,.txt,.rtf",
				},
			};
			const WebUploader: any = (window as any).WebUploader;
			const uploader = WebUploader.create(webUploaderOpt);
			this.$store.dispatch("setUploader", uploader);
			// 进入队列前触发
			uploader.on("beforeFileQueued", (file: any) => {
				if (file.size === 0 && opt.type !== "newPaper") {
					// this.$message({
					//   message: '文件大小为0kb，送检内容为空，请重新上传',
					//   type: 'error'
					// });
					// return false;
				}
			});
			// 当有文件被添加进队列的时候
			uploader.on("fileQueued", (file: any) => {
				if (opt.type === "newPaper") {
					const regex = /^([^@]+)@([^@]+)$/;
					if (regex.test(file.name)) {
						file.title = file.name.split("@")[0];
						file.author = file.name.split("@")[1].split(".")[0];
					} else {
						file.title = file.name;
					}
					file.fileState = "waiting";
					// this.uploadFileList.push(file);
					this.cacheUploadFileList.push(file);
				}
				// 单篇上传加遮罩层
				if (!opt.multiple) {
					this.$store.dispatch("setLoading", {
						isShow: true,
						text: "正在上传，请稍候！",
					});
				}
			});
			uploader.on("startUpload", (file: any, response: any) => {
				let countNum = this.contrastMethod === 1 ? 100 : 1;
				if (this.fileNum + uploader.getFiles().length > countNum) {
					this.$message({
						message: `本次可上传文献数量为${countNum - this.fileNum}篇，请重新选择或删除部分已上传文献`,
						type: "error",
					});
					// this.uploadFileList = this.uploadFileList.slice(0, this.fileNum);
					uploader.reset();
					this.cacheUploadFileList = [];
				} else {
					this.isCanCheck = true;
					this.fileNum = this.fileNum + uploader.getFiles().length;
					this.uploadFileList = this.uploadFileList.concat(this.cacheUploadFileList);
					this.copyUploadFileList = this.uploadFileList.concat([]);
				}
			});
			uploader.on("uploadSuccess", (file: any, response: any) => {
				if (!response.result) {
					this.$message({
						message: response.message,
						type: "error",
					});
					return false;
				}

				this.handleSuccess(file, response.result);
			});
			uploader.on("error", (error: any, file: any) => {
				this.handleError(error, file, opt.type);
			});
			uploader.on("uploadFinished", () => {
				this.isCanCheck = false;
				this.cacheUploadFileList = [];
				uploader.reset();
				this.$nextTick(() => {
					this.fileNum = this.uploadFileList.length;
					// 单篇上传加遮罩层
					if (!opt.multiple) {
						this.$store.dispatch("setLoading", {
							isShow: false,
							text: "正在加载...",
						});
					}
				});
			});
		},
	},
	created() {
		this.$store.dispatch("setPaperType", "newPaper");
		this.$store.dispatch("setCheckType", "upload");
		this.getTaskList();
		this.getNotCheckList();
		this.$nextTick(() => {
			this.initUploader("#newPaper", {
				multiple: true,
				fileNumLimit: 100,
				type: "newPaper",
			});
		});
	},
	mounted() {
		const cacheTips = localStorage.getItem("alShowToast");
		let isShow = cacheTips ? JSON.parse(cacheTips) : this.isTips;
		if (!isShow) {
			this.isTipsShow = true;
		}
	},
});
